/**
 * Abstract logistics / route visualization — no third-party assets, scales cleanly.
 */
export default function LogisticsHeroIllustration({
  accent = '#1769ff',
  className = '',
}: {
  accent?: string;
  className?: string;
}) {
  return (
    <svg
      viewBox="0 0 440 320"
      className={`w-full h-auto ${className}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <defs>
        <linearGradient id="lh-route" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={accent} stopOpacity="0.95" />
          <stop offset="100%" stopColor={accent} stopOpacity="0.45" />
        </linearGradient>
        <filter id="lh-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="3" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      {/* Map grid */}
      <g opacity="0.35" stroke="currentColor" className="text-slate-300">
        {Array.from({ length: 9 }).map((_, i) => (
          <line key={`v${i}`} x1={40 + i * 45} y1="24" x2={40 + i * 45} y2="296" strokeWidth="0.75" />
        ))}
        {Array.from({ length: 7 }).map((_, i) => (
          <line key={`h${i}`} x1="24" y1={36 + i * 44} x2="416" y2={36 + i * 44} strokeWidth="0.75" />
        ))}
      </g>
      {/* Hubs */}
      <circle cx="88" cy="92" r="10" fill={accent} fillOpacity="0.15" />
      <circle cx="88" cy="92" r="5" fill={accent} />
      <circle cx="352" cy="228" r="10" fill={accent} fillOpacity="0.15" />
      <circle cx="352" cy="228" r="5" fill={accent} />
      {/* Optimized route */}
      <path
        d="M 88 92 C 140 72, 180 120, 220 108 S 300 88, 338 140 S 360 200, 352 228"
        stroke="url(#lh-route)"
        strokeWidth="3.5"
        strokeLinecap="round"
        fill="none"
        filter="url(#lh-glow)"
      />
      {/* Stops */}
      {[
        [168, 118],
        [248, 102],
        [318, 152],
      ].map(([x, y], i) => (
        <g key={i}>
          <circle cx={x} cy={y} r="7" fill="#fff" stroke={accent} strokeWidth="2" />
          <text
            x={x}
            y={y + 4}
            textAnchor="middle"
            fill={accent}
            fontSize="9"
            fontWeight="700"
            fontFamily="system-ui, sans-serif"
          >
            {i + 1}
          </text>
        </g>
      ))}
      {/* Truck */}
      <g transform="translate(318, 198)">
        <rect x="0" y="8" width="52" height="28" rx="5" fill="#1e293b" />
        <rect x="36" y="4" width="22" height="20" rx="3" fill={accent} fillOpacity="0.9" />
        <circle cx="14" cy="40" r="6" fill="#334155" />
        <circle cx="40" cy="40" r="6" fill="#334155" />
        <rect x="6" y="14" width="10" height="8" rx="1" fill="#e2e8f0" fillOpacity="0.5" />
      </g>
      {/* Pulse ring */}
      <circle cx="88" cy="92" r="18" stroke={accent} strokeWidth="1" strokeOpacity="0.35" fill="none">
        <animate attributeName="r" values="14;22;14" dur="3s" repeatCount="indefinite" />
        <animate attributeName="opacity" values="0.5;0;0.5" dur="3s" repeatCount="indefinite" />
      </circle>
    </svg>
  );
}
